export default [
    {
        path: 'encaminhamentos/:id',
        component: require('./Read').default,
        meta: { middleware: 'auth', controller: 'EncaminhamentoController' }
    },
    {
        path: 'encaminhamentos/edit/:id',
        component: require('./Edit').default,
        meta: { middleware: 'auth', controller: 'EncaminhamentoController' },
    },
    {
        path: 'encaminhamentos/show/:id',
        component: require('./Show').default,
        meta: {
            middleware: 'auth',
            controller: 'EncaminhamentoController'
        }
    },
    {
        path: 'relatorios/encaminhamentos',
        component: require('./reports/Reports').default,
        redirect: 'relatorios/encaminhamentos/home',
        meta: { middleware: 'auth', controller: 'RelatorioEncaminhamentoController' },
        children: [{
            path: 'home',
            name: 'relatorios_home_encaminhamentos',
            component: require('./reports/includes/Home').default,
            meta: { middleware: 'auth', controller: 'RelatorioEncaminhamentoController' },
        }, {
            path: 'graficos',
            name: 'graficos_encaminhamentos',
            component: require('./reports/includes/Graficos').default,
            meta: { middleware: 'auth', controller: 'RelatorioEncaminhamentoController' },
        }
        ]
    }
];


